import BatchCreate from './views/Create.vue';

const routes = [
  {
    path: '/batch/legal-person/create',
    name: 'Batch-Legal-Person',
    component: BatchCreate,
    meta: {
      tag: 'cnpj',
    },
  },
  {
    path: '/batch/physical-person/create',
    name: 'Batch-Physical-Person',
    component: BatchCreate,
    meta: {
      tag: 'cpf',
    },
  },
  {
    path: '/batch/vehicle/create',
    name: 'Batch-Vehicle',
    component: BatchCreate,
    meta: {
      tag: 'vehicles',
    },
  },
  {
    path: '/batch/property/create',
    name: 'Batch-Property',
    component: BatchCreate,
    meta: {
      tag: 'properties',
    },
  },
  {
    path: '/batch/other/create',
    name: 'Batch-Other',
    component: BatchCreate,
    meta: {
      tag: 'others',
    },
  },
];

export default routes;
